<style scoped>
b {
    font-size: medium
}
</style>

<template>
    <v-container fluid px-3 pt-3>
        <v-row row wrap>
            <v-col cols="12">
                <h3>MOTHER'S WORKSHEET FOR CHILD'S BIRTH CERTIFICATE</h3>
                <v-divider></v-divider>
            </v-col>
            <v-col cols="12" v-if="!isSaved && !isSubmitted">
                The information you provide below will be used to complete your child’s birth certificate.
                The birth certificate is a document that will be used for legal purposes to prove your child’s age, citizenship, and parentage.
                Your child throughout his or her life will use the information from this document.
                Please take care to answer each question as accurately as possible.
                If you have a problem with some of the questions, please ask the birth certificate clerk in the hospital for assistance.<br>

            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-progress-circular v-if="isLoading" indeterminate :size="65" :width="5"></v-progress-circular>
            </v-col>
            <v-col>
                <div v-if="mothersWorksheetDto.completed">
                    <b style="color:red; font-size:large;">SUBMITTED</b>
                </div>
            </v-col>
        </v-row>
        <v-row row wrap v-show="!isSaved && !isSubmitted && !isLoading">
            <v-col>
                <v-card>
                    <v-form v-model="formValid" ref="mothersWorksheetForm">
                        <v-container>
                            <b style="color:red;">* Denotes a required field.</b>
                            <!-- Child Information Section -->
                            <v-row>
                                <v-col cols="12">
                                    <b>1. Child's Name<b style="color:red;">*</b> - </b>
                                    This should be the name that child will use throughout life.
                                    The child’s given first and middle names may be changed within one year of the date of birth.
                                    <b>The last name(s) entered here may only be changed by court order or by an Affidavit Acknowledging paternity.</b>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <name ref="childNameRef" v-model="mothersWorksheetDto.childName" :isRequired="true">
                                    </name>
                                </v-col>
                            </v-row>

                            <!-- Mother's information Section -->
                            <v-row>
                                <v-col cols="12">
                                    <b>2. Mother's Current Legal Name<b style="color:red;">*</b> -</b>
                                </v-col>
                            </v-row>
                            <v-row align="center">
                                <v-col cols="12">
                                    <name v-model="mothersWorksheetDto.mothersLegalName" :isRequired="true" ref="mothersLegalNameRef">
                                    </name>
                                </v-col>
                                <v-col cols="6">
                                    <b>List additional surnames if applicable. Note - some countries require surnames of both parents for dual citizenship -</b>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field label="Surname" v-model="mothersWorksheetDto.mothersLegalNameLast2" ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row align="center">
                                <v-col cols="6">
                                    <b>3. Mother's Date of Birth<b style="color:red;">*</b> -</b>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field label="Birthdate" type="date" v-model="mothersWorksheetDto.momDateOfBirth" required :rules="requiredDateRule" ref="momBirthRef">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <b>4. Mother's Name Before First Marriage (Maiden Name)<b style="color:red;">*</b> -</b>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <name v-model="mothersWorksheetDto.mothersPriorName" :isRequired="true" ref="mothersPriorNameRef">
                                    </name>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <b>5. Mother's Place of Birth<b style="color:red;">*</b> - </b>Select the U.S. State, U.S. Territory, or Foreign Country:
                                </v-col>
                            </v-row>
                            <v-row align="center">
                                <v-col cols="6">
                                    <v-select @change="getStatesOrTerritoriesMother()" v-model="mothersWorksheetDto.momBirthCountryId" required :rules="requiredDateRule"
                                              :items="countries"
                                              item-value="id"
                                              item-text="description"
                                              label="Birth Country">
                                    </v-select>
                                </v-col>
                                <v-col cols="6" v-if="mothersWorksheetDto.momBirthCountryId == 377 || mothersWorksheetDto.momBirthCountryId == 152">
                                    <v-select v-model="mothersWorksheetDto.momBirthStateId"
                                              :items="motherStates"
                                              item-value="id"
                                              item-text="description"
                                              label="Birth State, Province, or Territory">
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <b>6. Mother's Residence, Address, and Contact Information<b style="color:red;">*</b> - </b>
                                    This should be the place at which the mother has set up housekeeping.
                                    <b>It is not to be a temporary residence used during a visit or vacation.</b>
                                    Residence during a tour of military duty or during attendance at college should be entered.
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <addr id="mothersResidence" v-model="mothersWorksheetDto.residence" :isRequired="true" ref="mothersResidenceRef"></addr>
                                </v-col>
                            </v-row>
                            <v-row align="center">
                                <v-col cols="6">
                                    <b>Is this residence inside the city limits?<b style="color:red;">*</b></b>
                                </v-col>
                                <v-col cols="3">
                                    <v-checkbox label="YES" v-model="insideLimitsYes"></v-checkbox>
                                </v-col>
                                <v-col cols="3">
                                    <v-checkbox label="NO" v-model="insideLimitsNo"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row align="center">
                                <v-col cols="6">
                                    <b>Mother's Primary Telephone/Cellular Phone Number<b style="color:red;">*</b> - </b>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field v-model="mothersWorksheetDto.momPhone" required :rules="requiredRule"
                                                  label="Mother's Phone #"
                                                  placeholder="(999) 000 0000">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <b>Mother's Email Address<b style="color:red;">*</b> -</b>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field v-model="mothersWorksheetDto.momEmail" required :rules="requiredRule"
                                                  label="Mother's Email"
                                                  placeholder="name@example.com">
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <!-- Other Parent Information -->
                            <v-row align="center">
                                <v-col cols="12">
                                    <b>7. <u>Mother's Marital Status<b style="color:red;">*</b> -<b style="color:red;"> VERY IMPORTANT </b></u>- ITEMS 7 AND 8 ESTABLISH <u>PATERNITY</u> FOR THE CHILD.</b>
                                </v-col>
                                <v-col cols="6">
                                    <b>a. Was the Mother <b style="color:red;"><u>married to anyone</u></b> within the 300 days prior to birth?</b>
                                </v-col>
                                <v-col cols="6">
                                    <v-select v-model="mothersWorksheetDto.marriedYN"
                                              :items="yesNoMarried"
                                              item-value="id"
                                              item-text="description"
                                              required
                                              :rules="requiredDateRule"
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row align="center" v-if="mothersWorksheetDto.marriedYN == '1'">
                                <v-col cols="6">
                                    <b>b. If <a style="color:red;">YES</a>, is the spouse the father/parent of the child?</b>
                                </v-col>
                                <v-col cols="6">
                                    <v-select v-model="mothersWorksheetDto.husbandFatherYN"
                                              :items="yesNoSpouseFather"
                                              item-value="id"
                                              item-text="description"
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row align="center" v-if="mothersWorksheetDto.marriedYN == '2' || mothersWorksheetDto.husbandFatherYN == '2'">
                                <v-col cols="12">
                                    <b>8. <u>Paternity Acknowledgement</u> - Complete if the mother <b style="color:red;"><u>was not married</u></b> to the child’s natural/biological father.</b>
                                </v-col>
                                <v-col cols="6">
                                    <b>a. Has the natural/biological father signed an Affidavit Acknowledging Paternity?</b>
                                </v-col>
                                <v-col cols="6">
                                    <v-select v-model="mothersWorksheetDto.affidavitYN"
                                              :items="yesNo"
                                              item-value="id"
                                              item-text="description"
                                    ></v-select>
                                </v-col>
                                <template v-if="mothersWorksheetDto.marriedYN == 1">
                                    <v-col cols="6">
                                        <b>b. If the mother was married, has her husband/spouse signed an affidavit <u>denying </u>paternity?</b>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-select v-model="mothersWorksheetDto.denialYN"
                                                  :items="yesNo"
                                                  item-value="id"
                                                  item-text="description"
                                        ></v-select>
                                    </v-col>
                                </template>
                                <v-col cols="12">
                                    For more information about paternity acknowledgement:
                                    <v-btn class="text-only" @click="openAffidavitPage()">Affidavit Info</v-btn>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <b>9. Father/Parent's Current Legal Name - </b> If the mother was unmarried throughout her pregnancy, a <u>father</u> may only be
                                    named if an Affidavit Acknowledging Paternity is signed. If the mother was married at any time during the pregnancy
                                    (300 days prior to birth), the name of the <u>spouse</u> <b> must</b> be entered as the father/parent unless the natural/biological father
                                    signs an Affidavit Acknowledging Paternity. If the <u>spouse</u> does not sign an affidavit <u>denying </u>paternity, contact Vital
                                    Statistics Services immediately for guidance on completing the filing. The affidavit forms may be obtained from the birth
                                    certificate clerk.
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <name v-model="mothersWorksheetDto.otherName" ref="otherNameRef" :isRequired="otherParentInfoRequired">
                                    </name>
                                </v-col>
                            </v-row>
                            <v-row align="center">
                                <v-col cols="6">
                                    <b>List additional surnames if applicable. Note - some countries require surnames of both parents for dual citizenship -</b>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field label="Surname" v-model="mothersWorksheetDto.otherNameLast2"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row align="center">
                                <v-col cols="6">
                                    <b>10. Father/Parent's Date of Birth - </b>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field label="Birthdate" validate-on-blur type="date" v-model="mothersWorksheetDto.otherDateOfBirth"
                                                  required :rules="[otherParentRule(mothersWorksheetDto.otherDateOfBirth)]"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row align="center">
                                <v-col cols="12">
                                    <b>11. Father/Parent's Place of Birth - </b>Select the U.S. State, U.S. Territory, or Foreign Country:
                                </v-col>
                                <v-col cols="6">
                                    <v-select @change="getStatesOrTerritoriesFather()" v-model="mothersWorksheetDto.otherBirthCountryId"
                                              :items="countries"
                                              item-text="description"
                                              item-value="id"
                                              label="Birth Country"
                                              required
                                              :rules="[otherParentRule(mothersWorksheetDto.otherBirthCountryId)]"></v-select>
                                </v-col>
                                <v-col cols="6" v-if="mothersWorksheetDto.otherBirthCountryId == 377 || mothersWorksheetDto.otherBirthCountryId == 152">
                                    <v-select v-model="mothersWorksheetDto.otherBirthStateId"
                                              :items="fatherStates"
                                              item-value="id"
                                              item-text="description"
                                              label="Birth State, Province, or Territory"
                                              required
                                              :rules="[otherParentRule(mothersWorksheetDto.otherBirthStateId)]">
                                    </v-select>
                                </v-col>
                            </v-row>

                            <!-- Information -->
                            <v-row>
                                <v-col cols="12">
                                    <b>12. Mother's Mailing Address and Contact Information -</b> If same as Residence Address, skip to question 13.
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <addr v-model="mothersWorksheetDto.mailingAddress" ref="mothersMailingAddressRef"></addr>
                                </v-col>
                            </v-row>
                            <v-row align="start">
                                <v-col cols="12">
                                    <b>13. Information Released to Obtain a Social Security Number?<b style="color:red;">*</b></b>
                                    Check "YES" if the parents wish to have information released from this form to the Social Security Administration to assign a Social Security number to this child.
                                </v-col>
                                <v-col cols="8">
                                    <b style="color:red;">A Social Security card for the child will be sent directly to the Mother’s Mailing Address</b>
                                </v-col>
                                <v-col cols="2">
                                    <v-checkbox label="YES" v-model="releaseSocialYes"></v-checkbox>
                                </v-col>
                                <v-col cols="2">
                                    <v-checkbox label="NO" v-model="releaseSocialNo"></v-checkbox>
                                </v-col>
                                <v-col cols="12">
                                    <b>14. Information Released to Department of Health Public Health Nurse County Services?</b>
                                </v-col>
                                <v-col cols="10">
                                    A Public Health Nurse Representative will contact mothers to provide information regarding services available in her community.
                                    Check “NO” if the mother does NOT want to obtain information regarding services provided by Public Health Nursing in her community.
                                </v-col>
                                <v-col cols="2">
                                    <v-checkbox style="align:center" label="NO" v-model="refuseCountyServices"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <b>15. Parents' Social Security Numbers<b style="color:red;">*</b> -</b>
                                </v-col>
                                <v-col cols="12">
                                    Furnishing the parents’ Social Security Numbers is required by Federal Law, 42 USC 405(c) (section205(c) of the Social Security Act).
                                    The numbers will be made available to the Department of Family Services to assist with child support enforcement activities and to the Internal Revenue Service for the purpose of determining Earned Income Tax Credit compliance.
                                </v-col>
                            </v-row>
                            <v-row align="center" >
                                <v-col cols="4">
                                    <b>Mother's SSN</b>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field label="Example NNN-NN-NNNN" v-model="mothersWorksheetDto.mothersSSN" required :rules="ssnRule">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-checkbox style="align:center" label="No SSN" v-model="noSSNMother"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <b>Father/Parent's SSN</b>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field label="Example NNN-NN-NNNN" v-model="mothersWorksheetDto.otherSSN" required :rules="[otherParentRule(mothersWorksheetDto.otherSSN), otherParentSSNRule(mothersWorksheetDto.otherSSN)]">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-checkbox style="align:center" label="No SSN" v-model="noSSNOther"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <!-- Statistics -->
                            <v-row row wrap>
                                <v-col cols="12">
                                    The following information is needed to compile statistics to be used for planning and evaluating health programs for expectant mothers and newborn infants. It will not be included on certified copies of the birth certificate.
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <b>16. Mother's Education<b style="color:red;">*</b> - </b>
                                    Select the item that best describes the highest degree or level of school completed at the time of delivery.
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-select v-model="mothersWorksheetDto.educationId"
                                              :items="educationTypes"
                                              item-text="description"
                                              item-value="id"
                                              label="Education Level"
                                              required
                                              :rules="requiredDateRule">
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row align="center">
                                <v-col cols="12">
                                    <b>17. Mother's Hispanic Origin<b style="color:red;">*</b> - </b>
                                    Select the item that best describes whether the mother is Spanish/ Hispanic/ Latina. Select “NO” if the mother is not Spanish/ Hispanic/ Latina.
                                </v-col>
                                <v-col cols="6">
                                    <v-select v-model="mothersWorksheetDto.hispanicOriginId"
                                              :items="femaleHispanicTypes"
                                              item-text="description"
                                              item-value="id"
                                              label="Origin"
                                              required
                                              :rules="requiredDateRule">
                                    </v-select>
                                </v-col>
                                <v-col cols="6" v-if="mothersWorksheetDto.hispanicOriginId == '5'">
                                    <v-text-field label="Other Spanish/Hispanic/Latina" v-model="mothersWorksheetDto.hispanicOriginOtherText"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row align="start">
                                <v-col cols="12">
                                    <b>18. Mother's Race<b style="color:red;">*</b> - </b>
                                    Check one or more races to indicate what the mother considers herself to be.
                                </v-col>
                                <v-col cols="4">
                                    <!-- White -->
                                    <v-checkbox v-model="mothersWorksheetDto.mothersRace.white" label="White"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Black or African American -->
                                    <v-checkbox v-model="mothersWorksheetDto.mothersRace.blackOrAfricanAmerican" label="Black or African American"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- American Indian or Alaskan Native -->
                                    <v-checkbox v-model="mothersWorksheetDto.mothersRace.americanIndianOrAlaskanNative" label="American Indian or Alaskan Native"></v-checkbox>
                                    <v-text-field v-if="mothersWorksheetDto.mothersRace.americanIndianOrAlaskanNative" label="Name of enrolled or principal tribe"
                                                  v-model="mothersWorksheetDto.mothersRace.americanIndianOrAlaskanNativeText" required :rules="requiredRule"></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Asian Indian -->
                                    <v-checkbox v-model="mothersWorksheetDto.mothersRace.asianIndian" label="Asian Indian"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Chinese -->
                                    <v-checkbox v-model="mothersWorksheetDto.mothersRace.chinese" label="Chinese"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Filipina -->
                                    <v-checkbox v-model="mothersWorksheetDto.mothersRace.filipino" label="Filipina"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Japanese -->
                                    <v-checkbox v-model="mothersWorksheetDto.mothersRace.japanese" label="Japanese"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Korean -->
                                    <v-checkbox v-model="mothersWorksheetDto.mothersRace.korean" label="Korean"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Vietnamese -->
                                    <v-checkbox v-model="mothersWorksheetDto.mothersRace.vietnamese" label="Vietnamese"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Other Asian -->
                                    <v-checkbox v-model="mothersWorksheetDto.mothersRace.otherAsian" label="Other Asian"></v-checkbox>
                                    <v-text-field v-if="mothersWorksheetDto.mothersRace.otherAsian" label="Other Asian" v-model="mothersWorksheetDto.mothersRace.otherAsianText"
                                                  required :rules="requiredRule"></v-text-field>
                                    <v-text-field v-if="mothersWorksheetDto.mothersRace.otherAsian" label="Other Asian 2" v-model="mothersWorksheetDto.mothersRace.otherAsianText2"></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Native Hawaiian -->
                                    <v-checkbox v-model="mothersWorksheetDto.mothersRace.nativeHawaiin" label="Native Hawaiian"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Guamanian or Chamorro -->
                                    <v-checkbox v-model="mothersWorksheetDto.mothersRace.guamanianOrChamorro" label="Guamanian or Chamorro"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Samoan -->
                                    <v-checkbox v-model="mothersWorksheetDto.mothersRace.samoan" label="Samoan"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Other Pacific Islander -->
                                    <v-checkbox v-model="mothersWorksheetDto.mothersRace.otherPacificIslander" label="Other Pacific Islander"></v-checkbox>
                                    <v-text-field v-if="mothersWorksheetDto.mothersRace.otherPacificIslander" label="Other Pacific Islander" v-model="mothersWorksheetDto.mothersRace.otherPacificIslanderText"
                                                  required :rules="requiredRule"></v-text-field>
                                    <v-text-field v-if="mothersWorksheetDto.mothersRace.otherPacificIslander" label="Other Pacific Islander 2" v-model="mothersWorksheetDto.mothersRace.otherPacificIslanderText2"></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Other -->
                                    <v-checkbox v-model="mothersWorksheetDto.mothersRace.other" label="Other"></v-checkbox>
                                    <v-text-field v-if="mothersWorksheetDto.mothersRace.other" label="Other" v-model="mothersWorksheetDto.mothersRace.otherText"
                                                  required :rules="requiredRule"></v-text-field>
                                    <v-text-field v-if="mothersWorksheetDto.mothersRace.other" label="Other 2" v-model="mothersWorksheetDto.mothersRace.otherText2"></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Unknown -->
                                    <v-checkbox v-model="mothersWorksheetDto.mothersRace.unknown" label="Unknown"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Refuse -->
                                    <v-checkbox v-model="mothersWorksheetDto.mothersRace.decline" label="Refuse"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Not Obtainable -->
                                    <v-checkbox v-model="mothersWorksheetDto.mothersRace.notObtainable" label="Not Obtainable"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <b>19. Father/Parent's Education - </b>
                                    Select the item that best describes the highest degree or level of school completed at the time of delivery
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-select v-model="mothersWorksheetDto.otherEducationId"
                                              :items="educationTypes"
                                              item-text="description"
                                              item-value="id"
                                              label="Education Level"
                                              required
                                              :rules="[otherParentRule(mothersWorksheetDto.otherEducationId)]">
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row align="center">
                                <v-col cols="12">
                                    <b>20. Father/Parent's Hispanic Origin - </b>
                                    Select the item that best describes whether the father/parent is Spanish/ Hispanic/ Latino. Select “NO” if the father/parent is not Spanish/ Hispanic/ Latino.
                                </v-col>
                                <v-col cols="6">
                                    <v-select v-model="mothersWorksheetDto.otherHispanicOriginId"
                                              :items="hispanicTypes"
                                              item-text="description"
                                              item-value="id"
                                              label="Origin"
                                              required
                                              :rules="[otherParentRule(mothersWorksheetDto.otherHispanicOriginId)]">
                                    </v-select>
                                </v-col>
                                <v-col cols="6" v-if="mothersWorksheetDto.otherHispanicOriginId == '5'">
                                    <v-text-field label="Other Spanish/Hispanic/Latino" v-model="mothersWorksheetDto.otherHispanicOriginOtherText"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row align="start">
                                <v-col cols="12">
                                    <b>21. Father/Parent's Race - </b>
                                    Check one or more races to indicate what the father/other parent considers himself/themselves to be.
                                </v-col>
                                <v-col cols="4">
                                    <!-- White -->
                                    <v-checkbox v-model="mothersWorksheetDto.otherRace.white" label="White"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Black or African American -->
                                    <v-checkbox v-model="mothersWorksheetDto.otherRace.blackOrAfricanAmerican" label="Black or African American"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- American Indian or Alaskan Native -->
                                    <v-checkbox v-model="mothersWorksheetDto.otherRace.americanIndianOrAlaskanNative" label="American Indian or Alaskan Native"></v-checkbox>
                                    <v-text-field v-if="mothersWorksheetDto.otherRace.americanIndianOrAlaskanNative" label="Name of enrolled or principal tribe"
                                                  v-model="mothersWorksheetDto.otherRace.americanIndianOrAlaskanNativeText" required :rules="requiredRule"></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Asian Indian -->
                                    <v-checkbox v-model="mothersWorksheetDto.otherRace.asianIndian" label="Asian Indian"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Chinese -->
                                    <v-checkbox  v-model="mothersWorksheetDto.otherRace.chinese" label="Chinese"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Filipino -->
                                    <v-checkbox v-model="mothersWorksheetDto.otherRace.filipino" label="Filipino"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Japanese -->
                                    <v-checkbox v-model="mothersWorksheetDto.otherRace.japanese" label="Japanese"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Korean -->
                                    <v-checkbox v-model="mothersWorksheetDto.otherRace.korean" label="Korean"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Vietnamese -->
                                    <v-checkbox v-model="mothersWorksheetDto.otherRace.vietnamese" label="Vietnamese"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Other Asian -->
                                    <v-checkbox v-model="mothersWorksheetDto.otherRace.otherAsian" label="Other Asian"></v-checkbox>
                                    <v-text-field v-if="mothersWorksheetDto.otherRace.otherAsian" label="Other Asian" v-model="mothersWorksheetDto.otherRace.otherAsianText"
                                                  required :rules="requiredRule"></v-text-field>
                                    <v-text-field v-if="mothersWorksheetDto.otherRace.otherAsian" label="Other Asian 2" v-model="mothersWorksheetDto.otherRace.otherAsianText2"></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Native Hawaiian -->
                                    <v-checkbox v-model="mothersWorksheetDto.otherRace.nativeHawaiin" label="Native Hawaiian"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Guamanian or Chamorro -->
                                    <v-checkbox v-model="mothersWorksheetDto.otherRace.guamanianOrChamorro" label="Guamanian or Chamorro"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Samoan -->
                                    <v-checkbox v-model="mothersWorksheetDto.otherRace.samoan" label="Samoan"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Other Pacific Islander -->
                                    <v-checkbox v-model="mothersWorksheetDto.otherRace.otherPacificIslander" label="Other Pacific Islander"></v-checkbox>
                                    <v-text-field v-if="mothersWorksheetDto.otherRace.otherPacificIslander" label="Other Pacific Islander" v-model="mothersWorksheetDto.otherRace.otherPacificIslanderText"
                                                  required :rules="requiredRule"></v-text-field>
                                    <v-text-field v-if="mothersWorksheetDto.otherRace.otherPacificIslander" label="Other Pacific Islander 2" v-model="mothersWorksheetDto.otherRace.otherPacificIslanderText2"></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Other -->
                                    <v-checkbox v-model="mothersWorksheetDto.otherRace.other" label="Other"></v-checkbox>
                                    <v-text-field v-if="mothersWorksheetDto.otherRace.other" label="Other" v-model="mothersWorksheetDto.otherRace.otherText"
                                                  required :rules="requiredRule"></v-text-field>
                                    <v-text-field v-if="mothersWorksheetDto.otherRace.other" label="Other 2" v-model="mothersWorksheetDto.otherRace.otherText2"></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Unknown -->
                                    <v-checkbox v-model="mothersWorksheetDto.otherRace.unknown" label="Unknown"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Refuse -->
                                    <v-checkbox v-model="mothersWorksheetDto.otherRace.decline" label="Refuse"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <!-- Not Obtainable -->
                                    <v-checkbox v-model="mothersWorksheetDto.otherRace.notObtainable" label="Not Obtainable"></v-checkbox>
                                </v-col>
                            </v-row>

                            <!-- Other info -->
                            <v-row align="center">
                                <v-col cols="6">
                                    <b>22. Mother's Height?<b style="color:red;">*</b> </b>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field
                                        type="number"
                                        v-model="mothersWorksheetDto.heightFeet" required :rules="requiredFeetRule"
                                        label="Feet">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field
                                        type="number"
                                        v-model="mothersWorksheetDto.heightInches" required :rules="requiredInchRule"
                                        label="Inches">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row align="center">
                                <v-col cols="9">
                                    <b>23. Mother’s Pre-pregnancy Weight<b style="color:red;">*</b> </b> - mother’s weight immediately before she became pregnant?
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field
                                        v-model="mothersWorksheetDto.weight" required :rules="requiredRule"
                                        type="number"
                                        label="Pounds">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row align="center">
                                <v-col cols="9">
                                    <b>24. Did mother get WIC (Women, Infants, and Children) food for herself because she was pregnant with this child?<b style="color:red;">*</b></b>
                                </v-col>
                                <v-col cols="3">
                                    <v-select v-model="mothersWorksheetDto.wicYN"
                                              :items="yesNo"
                                              item-text="description"
                                              item-value="id"
                                              required
                                              :rules="requiredDateRule"
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <b>25. Cigarette Smoking Before and During Pregnancy<b style="color:red;">*</b> -</b>
                                    How many cigarettes OR packs of cigarettes did the MOTHER smoke on an average <u>day</u> during each of the following time periods?
                                    If the Mother never smoked, select the box and skip to question 26.
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-checkbox label="Never Smoked (Skip to Question 26)" @click="toggleZeros()" v-model="mothersWorksheetDto.neverSmoked"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row align="center">
                                <v-col cols="5">
                                    Three months <b style="color:red;">BEFORE</b> pregnancy
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field
                                        v-model="mothersWorksheetDto.beforePregnancyCigs"
                                        label="Cigarettes/Day">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="1">
                                    OR
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field
                                        v-model="mothersWorksheetDto.beforePregnancyPacks"
                                        label="Packs/Day">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row align="center">
                                <v-col cols="5">
                                    <b>First three months</b> of pregnancy
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field
                                        v-model="mothersWorksheetDto.firstThreePregnancyCigs"
                                        label="Cigarettes/Day">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="1">
                                    OR
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field
                                        v-model="mothersWorksheetDto.firstThreePregnancyPacks"
                                        label="Packs/Day">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row align="center">
                                <v-col cols="5">
                                    <b>Second three months</b> of pregnancy
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field
                                        v-model="mothersWorksheetDto.secondThreePregnancyCigs"
                                        label="Cigarettes/Day">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="1">
                                    OR
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field
                                        v-model="mothersWorksheetDto.secondThreePregnancyPacks"
                                        label="Packs/Day">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row align="center">
                                <v-col cols="5">
                                    <b>Last three months</b> of pregnancy
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field
                                        v-model="mothersWorksheetDto.finalThreePregnancyCigs"
                                        label="Cigarettes/Day">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="1">
                                    OR
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field
                                        v-model="mothersWorksheetDto.finalThreePregnancyPacks"
                                        label="Packs/Day">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row align="center">
                                <v-col cols="12">
                                    <b>26. Month Prenatal Care Began<b style="color:red;">*</b> -</b>
                                </v-col>
                                <v-col cols="12">
                                    Enter the month of pregnancy when the mother began going to the doctor for prenatal
                                    care. <u>Please only enter a value between 01 through 10.</u> If the mother did not receive prenatal care, please enter “NONE” in the space provided
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field label="Month Prenatal Care Began" v-model="mothersWorksheetDto.prenatalCare" required :rules="prenatalCareRule"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    (Example: 1 = Prenatal care began the <b>first month</b> of pregnancy and 2 = Prenatal care began the second month of pregnancy.)
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
        <template v-if="!isSubmitted && !isSaved && !mothersWorksheetDto.completed">
            <v-row>
                <v-col cols="12" v-if="showErrors() && !isSaved && !isSubmitted">
                    <label>Please correct the following errors:</label>
                </v-col>
                <v-col cols="12">
                    <ul>
                        <li class="red--text" v-for="error in errors" :key="error">{{error}}</li>
                    </ul>
                </v-col>
            </v-row>
            <v-row align="center" justify="center">
                <v-col cols="12">
                    <u style="color:red;font-style:italic;">Before submitting, please make sure ALL applicable questions have been answered.
                        If there are blank items, they may have a negative impact on the filing of the birth certificate.</u><br><br>
                    By clicking SUBMIT, I certify the information provided for this certificate is correct to the best of my knowledge and belief.<br>
                    I also acknowledge that submitting this form constitutes an electronic signature and will be considered as a handwritten signature for all purposes and shall have
                    the same force and effect as a handwritten signature.
                </v-col>
            </v-row>
        </template>
        <v-row v-if="!mothersWorksheetDto.completed">
            <v-col cols="12" v-if="isSubmitted">
                <b>Worksheet has been submitted! The reference number for this worksheet is <u>{{ mothersWorksheetDto.portalMothersWorksheetId }}</u>.</b>
            </v-col>
            <v-col cols="12" v-if="isSaved && !isSubmitted">
                <b style="background-color:yellow;">The worksheet has been saved. Go to your inbox to continue working on worksheet <u>{{ mothersWorksheetDto.portalMothersWorksheetId }}</u>.</b>
            </v-col>
            <v-col cols="6" v-if="!isSaved && !isSubmitted">
                <v-btn color="secondary" :disabled="isSubmitted || isLoading" @click="sendMothersWorksheet(true)">
                    SUBMIT
                </v-btn>
            </v-col>
            <v-col cols="6" v-if="!isSaved && !isSubmitted">
                <v-btn color="secondary" :disabled="isLoading || isSubmitted" @click="sendMothersWorksheet(false)">
                    SAVE UNFINISHED
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import mothersWorksheetService from '@/services/mothersWorksheetService'
import Addr from '@/components/Address'
import Name from '@/components/Name'
import lookupService from '@/services/lookupService'

export default {
    components: {
        Addr,
        Name
    },
    mounted: function () {
        window.scrollTo(0, 0)
        lookupService.GetEducationTypes(this.$http).then(response => {
            this.educationTypes = response.data
        })
        lookupService.GetHispanicOriginTypes(this.$http).then(response => {
            this.hispanicTypes = response.data
        })
        lookupService.GetFemaleHispanicOriginTypes(this.$http).then(response => {
            this.femaleHispanicTypes = response.data
        })
        lookupService.GetCountries(this.$http).then(response => {
            this.countries = response.data
        })
        lookupService.GetStates(this.$http).then(response => {
            this.states = response.data
        })
        lookupService.GetCanadianTerritories(this.$http).then(response => {
            this.territories = response.data
        })
        this.yesNo = lookupService.YesNoList

        if (this.$route.query.worksheetId != null) {
            this.isLoading = true
            mothersWorksheetService.getWorksheetById(this.$http, this.$route.query.worksheetId).then(response => {
                if (response.data != null) {
                    this.setupMothersWorksheet(response.data)
                }
                this.isLoading = false
            })
        }
    },
    beforeRouteLeave (to, from, next) {
        if (!this.isSaved && !this.isSubmitted) {
            if (confirm('Unsaved progress will be lost. Do you want to proceed?')) {
                next()
            } else {
                next(false)
            }
        } else {
            next()
        }
    },
    data: () => {
        return {
            errors: [],
            requiredRule: [v => !!v || 'Required', v => (v && v.toString().trim() !== '') || 'Invalid Input'],
            requiredFeetRule: [v => !!v || 'Required', v => (v >= 3 && v <= 8) || 'Please enter a value between 3 and 8'],
            requiredInchRule: [v => (v >= 0 && v < 12) || 'Please enter a number between 0 and 11'],
            requiredDateRule: [v => !!v || 'Required'],
            ssnRule: [v => (v && /^999999999|((?!(000|666|9))(\d{3}-?(?!(00))\d{2}-?(?!(0000))\d{4}))$/.test(v)) || 'Please input a valid SSN'],
            prenatalCareRule: [v => !!v || 'Required', v => ((v >= 1 && v <= 10) || v === 'NONE') || 'Please enter a number between 1 and 10 or NONE'],
            formValid: false,
            isLoading: false,
            isSubmitted: false,
            isSaved: false,
            refuseCountyServices: false,
            releaseSocialYes: false,
            releaseSocialNo: false,
            insideLimitsYes: false,
            insideLimitsNo: false,
            noSSNMother: false,
            noSSNOther: false,
            mothersWorksheetDto: {
                portalMothersWorksheetId: 0,
                childName: {},
                mothersLegalName: {},
                mothersLegalNameLast2: null,
                momDateOfBirth: null,
                mothersPriorName: {},
                momBirthCountryId: null,
                momBirthStateId: null,
                residence: {},
                momPhone: null,
                momEmail: null,
                insideLimits: null,
                marriedYN: null,
                affidavitYN: null,
                husbandFatherYN: null,
                denialYN: null,
                otherName: {},
                otherNameLast2: null,
                otherDateOfBirth: null,
                otherBirthCountryId: null,
                otherBirthStateId: null,
                mailingAddress: {},
                releaseSocial: null,
                releaseCountyServices: null,
                mothersSSN: null,
                otherSSN: null,
                educationId: null,
                hispanicOriginId: null,
                hispanicOriginOtherText: null,
                mothersRace: {
                    white: false,
                    blackOrAfricanAmerican: false,
                    americanIndianOrAlaskanNative: false,
                    americanIndianOrAlaskanNativeText: null, // new
                    asianIndian: false,
                    chinese: false,
                    filipino: false,
                    japanese: false,
                    korean: false,
                    vietnamese: false,
                    otherAsian: false,
                    otherAsianText: null,
                    otherAsianText2: null,
                    nativeHawaiin: false,
                    guamanianOrChamorro: false,
                    samoan: false,
                    otherPacificIslander: false,
                    otherPacificIslanderText: null,
                    otherPacificIslanderText2: null,
                    other: false,
                    otherText: null,
                    otherText2: null,
                    unknown: false,
                    decline: false,
                    notObtainable: false
                },
                otherEducationId: null,
                otherHispanicOriginId: null,
                otherHispanicOriginOtherText: null,
                otherRace: {
                    white: false,
                    blackOrAfricanAmerican: false,
                    americanIndianOrAlaskanNative: false,
                    americanIndianOrAlaskanNativeText: null, // new
                    asianIndian: false,
                    chinese: false,
                    filipino: false,
                    japanese: false,
                    korean: false,
                    vietnamese: false,
                    otherAsian: false,
                    otherAsianText: null,
                    otherAsianText2: null,
                    nativeHawaiin: false,
                    guamanianOrChamorro: false,
                    samoan: false,
                    otherPacificIslander: false,
                    otherPacificIslanderText: null,
                    otherPacificIslanderText2: null,
                    other: false,
                    otherText: null,
                    otherText2: null,
                    unknown: false,
                    decline: false,
                    notObtainable: false
                },
                heightFeet: null,
                heightInches: null,
                weight: null,
                wicYN: null,
                prenatalCare: null, //string, 1-10 or NONE
                neverSmoked: false, // new
                beforePregnancyCigs: null,
                beforePregnancyPacks: null,
                firstThreePregnancyCigs: null,
                firstThreePregnancyPacks: null,
                secondThreePregnancyCigs: null,
                secondThreePregnancyPacks: null,
                finalThreePregnancyCigs: null,
                finalThreePregnancyPacks: null
            },
            sexes: [
                { sex: 'Male' },
                { sex: 'Female' }
            ],
            educationTypes: [
            ],
            hispanicTypes: [
            ],
            femaleHispanicTypes: [
            ],
            countries: [
            ],
            states: [
            ],
            territories: [
            ],
            motherStates: [
            ],
            fatherStates: [
            ],
            yesNo: [
            ],
            yesNoMarried: [
                { id: 1, description: 'YES (Answer "b")' },
                { id: 2, description: 'NO (Skip to question 8)' }
            ],
            yesNoSpouseFather: [
                { id: 1, description: 'YES (Skip to question 9)' },
                { id: 2, description: 'NO (Answer question 8)' }
            ],
            formErrors: {}
        }
    },
    watch: {
        noSSNMother: function (val) {
            if (val) {
                this.mothersWorksheetDto.mothersSSN = '999999999'
            } else {
                this.mothersWorksheetDto.mothersSSN = null
            }
        },
        noSSNOther: function (val) {
            if (val) {
                this.mothersWorksheetDto.otherSSN = '999999999'
            } else {
                this.mothersWorksheetDto.otherSSN = null
            }
        }
    },
    computed: {
        otherParentInfoRequired () {
            return this.mothersWorksheetDto.affidavitYN === 1 ||
            (this.mothersWorksheetDto.marriedYN === 1 && this.mothersWorksheetDto.husbandFatherYN === 1)
        }
    },
    methods: {
        showErrors () {
            return !!this.errors && this.errors.length > 0
        },
        openAffidavitPage () {
            window.open('https://www.google.com/url?q=https://health.wyo.gov/admin/vitalstatistics/paternityestablishment/&sa=D&source=hangouts&ust=1615667871890000&usg=AFQjCNGHSPG4o00mBwqQEedArWz97UXVJg')
        },
        async sendMothersWorksheet (complete) {
            if (!complete) {
                this.isLoading = true
                if (this.releaseSocialYes) {
                    this.mothersWorksheetDto.releaseSocial = true
                } else if (this.releaseSocialNo) {
                    this.mothersWorksheetDto.releaseSocial = false
                } else {
                    this.mothersWorksheetDto.releaseSocial = null
                }
                if (this.insideLimitsYes) {
                    this.mothersWorksheetDto.insideLimits = true
                } else if (this.insideLimitsNo) {
                    this.mothersWorksheetDto.insideLimits = false
                } else {
                    this.mothersWorksheetDto.insideLimits = null
                }
                this.mothersWorksheetDto.releaseCountyServices = !this.refuseCountyServices
                this.mothersWorksheetDto.childName = this.$refs.childNameRef.nameDto
                this.mothersWorksheetDto.mothersLegalName = this.$refs.mothersLegalNameRef.nameDto
                this.mothersWorksheetDto.mothersPriorName = this.$refs.mothersPriorNameRef.nameDto
                this.mothersWorksheetDto.residence = this.$refs.mothersResidenceRef.placeDTO
                this.mothersWorksheetDto.residence.county = (this.mothersWorksheetDto.residence.county || '').replace(' County', '')
                this.mothersWorksheetDto.mailingAddress = this.$refs.mothersMailingAddressRef.placeDTO
                this.mothersWorksheetDto.mailingAddress.county = (this.mothersWorksheetDto.mailingAddress.county || '').replace(' County', '')
                this.mothersWorksheetDto.otherName = this.$refs.otherNameRef.nameDto
                mothersWorksheetService.mothersWorksheetInsertIncomplete(this.$http, this.mothersWorksheetDto).then(response => {
                    this.mothersWorksheetDto.portalMothersWorksheetId = response.data
                    this.isSaved = true
                    this.isLoading = false
                })
            } else {
                this.checkErrors()
                this.$refs.mothersWorksheetForm.validate()
                this.isLoading = true

                if (this.formValid && this.errors.length === 0 && confirm('Is all of the information on the form correct?')) {
                    this.mothersWorksheetDto.releaseCountyServices = !this.refuseCountyServices

                    this.mothersWorksheetDto.releaseCountyServices = !this.refuseCountyServices
                    this.mothersWorksheetDto.childName = this.$refs.childNameRef.nameDto
                    this.mothersWorksheetDto.mothersLegalName = this.$refs.mothersLegalNameRef.nameDto
                    this.mothersWorksheetDto.mothersPriorName = this.$refs.mothersPriorNameRef.nameDto
                    this.mothersWorksheetDto.residence = this.$refs.mothersResidenceRef.placeDTO
                    this.mothersWorksheetDto.mailingAddress = this.$refs.mothersMailingAddressRef.placeDTO
                    this.mothersWorksheetDto.otherName = this.$refs.otherNameRef.nameDto
                    mothersWorksheetService.mothersWorksheetInsertComplete(this.$http, this.mothersWorksheetDto).then(response => {
                        this.isLoading = false
                        this.isSubmitted = true
                        this.mothersWorksheetDto.portalMothersWorksheetId = response.data
                    })
                } else {
                    this.isLoading = false
                }
            }
        },
        setupMothersWorksheet (worksheet) {
            this.mothersWorksheetDto = worksheet
            this.$refs.childNameRef.setNameDto(worksheet.childName)
            this.$refs.mothersLegalNameRef.setNameDto(worksheet.mothersLegalName)
            this.$refs.mothersPriorNameRef.setNameDto(worksheet.mothersPriorName)
            this.$refs.mothersResidenceRef.placeDTO = this.mothersWorksheetDto.residence
            this.$refs.mothersMailingAddressRef.placeDTO = this.mothersWorksheetDto.mailingAddress
            this.$refs.otherNameRef.setNameDto(this.mothersWorksheetDto.otherName)
            if (this.mothersWorksheetDto.momDateOfBirth !== null) {
                this.mothersWorksheetDto.momDateOfBirth = this.dateToYYYYMMDD(new Date(this.mothersWorksheetDto.momDateOfBirth))
            }
            if (this.mothersWorksheetDto.otherDateOfBirth !== null) {
                this.mothersWorksheetDto.otherDateOfBirth = this.dateToYYYYMMDD(new Date(this.mothersWorksheetDto.otherDateOfBirth))
            }
            if (this.mothersWorksheetDto.insideLimits === null) {
                this.insideLimitsYes = false
                this.insideLimitsNo = false
            } else if (!this.mothersWorksheetDto.insideLimits) {
                this.insideLimitsYes = false
                this.insideLimitsNo = true
            } else {
                this.insideLimitsYes = true
                this.insideLimitsNo = false
            }

            if (this.mothersWorksheetDto.releaseSocial === null) {
                this.releaseSocialYes = false
                this.releaseSocialNo = false
            } else if (!this.mothersWorksheetDto.releaseSocial) {
                this.releaseSocialYes = false
                this.releaseSocialNo = true
            } else {
                this.releaseSocialYes = true
                this.releaseSocialNo = false
            }
            this.refuseCountyServices = !this.mothersWorksheetDto.releaseCountyServices

            this.getStatesOrTerritoriesMother()
            this.getStatesOrTerritoriesFather()

            this.checkErrors()
            this.$refs.mothersWorksheetForm.validate()
        },
        dateToYYYYMMDD (d) {
            return d && new Date(d.getTime() - (d.getTimezoneOffset() * 60 * 1000)).toISOString().split('T')[0]
        },
        checkRaces (race) {
            return race.white || race.blackOrAfricanAmerican || race.americanIndianOrAlaskanNative || race.asianIndian || race.chinese || race.filipino ||
                race.japanese || race.korean || race.vietnamese || race.otherAsian || race.nativeHawaiin || race.guamanianOrChamorro || race.samoan || race.otherPacificIslander ||
                race.other || race.unknown || race.decline || race.notObtainable
        },
        checkRaceText (race, questionNumber) {
            var questionText = 'Question ' + questionNumber + ': ' //`Question ${questionNumber || ''}: `
            if (race.americanIndianOrAlaskanNative && !race.americanIndianOrAlaskanNativeText) {
                this.errors.push(questionText + 'American Indian or Alaskan Native - Name of enrolled or principal tribe is required.')
            }
            if (race.otherAsian && !race.otherAsianText) {
                this.errors.push(questionText + 'Other Asian - Other Asian text is required.')
            }
            if (race.otherPacificIslander && !race.otherPacificIslanderText) {
                this.errors.push(questionText + 'Other Pacific Islander text is required.')
            }
            if (race.other && !race.otherText) {
                this.errors.push(questionText + 'Other (Race) text is required.')
            }
        },
        checkSmoking () {
            var dto = this.mothersWorksheetDto
            return dto.neverSmoked || ((!!dto.beforePregnancyCigs || !!dto.beforePregnancyPacks) &&
                (!!dto.firstThreePregnancyCigs || !!dto.firstThreePregnancyPacks) &&
                (!!dto.secondThreePregnancyCigs || !!dto.secondThreePregnancyPacks) &&
                (!!dto.finalThreePregnancyCigs || !!dto.finalThreePregnancyPacks))
        },
        toggleZeros () {
            if (this.mothersWorksheetDto.neverSmoked) {
                this.mothersWorksheetDto.beforePregnancyCigs = 0
                this.mothersWorksheetDto.firstThreePregnancyCigs = 0
                this.mothersWorksheetDto.secondThreePregnancyCigs = 0
                this.mothersWorksheetDto.finalThreePregnancyCigs = 0
            } else {
                this.mothersWorksheetDto.beforePregnancyCigs = null
                this.mothersWorksheetDto.firstThreePregnancyCigs = null
                this.mothersWorksheetDto.secondThreePregnancyCigs = null
                this.mothersWorksheetDto.finalThreePregnancyCigs = null
            }
        },
        getStatesOrTerritoriesMother () {
            if (this.mothersWorksheetDto.momBirthCountryId === 377) {
                this.motherStates = this.states
            } else if (this.mothersWorksheetDto.momBirthCountryId === 152) {
                this.motherStates = this.territories
            }
        },
        getStatesOrTerritoriesFather () {
            if (this.mothersWorksheetDto.otherBirthCountryId === 377) {
                this.fatherStates = this.states
            } else if (this.mothersWorksheetDto.otherBirthCountryId === 152) {
                this.fatherStates = this.territories
            }
        },
        checkErrors () {
            this.errors = []
            if (this.$refs.childNameRef.checkFields()) {
                this.errors.push('Question 1: Child\'s Full Name is required.')
            }
            if (this.$refs.mothersLegalNameRef.checkFields()) {
                this.errors.push('Question 2: Mother\'s Full Legal Name is required.')
            }
            if (!this.mothersWorksheetDto.momDateOfBirth) {
                this.errors.push('Question 3: Mother\'s Date of Birth is required.')
            }
            if (this.$refs.mothersPriorNameRef.checkFields()) {
                this.errors.push('Question 4: Mother\'s Full Name before first marriage is required.')
            }
            if (!this.mothersWorksheetDto.momBirthCountryId) {
                this.errors.push('Question 5: Mother\'s Birth Country is required.')
            }
            if ((this.mothersWorksheetDto.momBirthCountryId === 377 || this.mothersWorksheetDto.momBirthCountryId === 152) && this.mothersWorksheetDto.momBirthStateId == null) {
                this.errors.push('Question 5: Mother\'s Birth State is required.')
            }
            if (this.$refs.mothersResidenceRef.checkFields()) {
                this.errors.push('Question 6: Mother\'s Current Residence is required.')
            }
            if (this.insideLimitsYes) {
                this.mothersWorksheetDto.insideLimits = true
            } else if (this.insideLimitsNo) {
                this.mothersWorksheetDto.insideLimits = false
            } else {
                this.errors.push('Question 6: Inside City Limits is required. Please select either Yes or No.')
            }
            if (this.mothersWorksheetDto.marriedYN === null) {
                this.errors.push('Question 7a: Mother\'s Marital Status is required.')
            }
            if (this.mothersWorksheetDto.marriedYN === 1 && this.mothersWorksheetDto.husbandFatherYN === null) {
                this.errors.push('Question 7b: Whether or not spouse is other parent is required.')
            }
            if (this.mothersWorksheetDto.marriedYN === 2 || this.mothersWorksheetDto.husbandFatherYN === 2) {
                if (this.mothersWorksheetDto.affidavitYN == null) {
                    this.errors.push('Question 8a: Whether or not biological father has signed paternity affidavit is required.')
                }
                if (this.mothersWorksheetDto.marriedYN !== 2 && this.mothersWorksheetDto.denialYN == null) {
                    this.errors.push('Question 8b: Whether or not spouse has signed affidavit denying paternity is required.')
                }
            }
            if (this.otherParentInfoRequired) {
                if (this.$refs.otherNameRef.checkFields()) {
                    this.errors.push('Question 9: Father/Parent\'s Current Legal Name is required.')
                }
                if (!this.mothersWorksheetDto.otherDateOfBirth) {
                    this.errors.push('Question 10: Father/Parent\'s Date of Birth is required.')
                }
                if (!this.mothersWorksheetDto.otherBirthCountryId) {
                    this.errors.push('Question 11: Father/Parent\'s Birth Country is required.')
                }

                if ((this.mothersWorksheetDto.otherBirthCountryId === 377 || this.mothersWorksheetDto.otherBirthCountryId === 152) && this.mothersWorksheetDto.otherBirthStateId == null) {
                    this.errors.push('Question 11: Father/Parent\'s Birth State is required.')
                }
            }
            if (this.releaseSocialYes) {
                this.mothersWorksheetDto.releaseSocial = true
            } else if (this.releaseSocialNo) {
                this.mothersWorksheetDto.releaseSocial = false
            } else {
                this.errors.push('Question 13: Release information for a social security card is required. Please select either Yes or No.')
            }

            if (!this.mothersWorksheetDto.mothersSSN) {
                this.errors.push('Question 15: Mother\'s Social Security Number is required.')
            }
            if (this.otherParentInfoRequired && !this.mothersWorksheetDto.otherSSN) {
                this.errors.push('Question 15: Father/Parent\'s Social Security Number is required.')
            }
            if (!this.mothersWorksheetDto.educationId) {
                this.errors.push('Question 16: Mother\'s Education is required.')
            }
            if (!this.mothersWorksheetDto.hispanicOriginId) {
                this.errors.push('Question 17: Mother\'s Hispanic Origin is required.')
            }
            if (!this.checkRaces(this.mothersWorksheetDto.mothersRace)) {
                this.errors.push('Question 18: At least one race must be selected for the mother.')
            }
            this.checkRaceText(this.mothersWorksheetDto.mothersRace, '18')
            if (this.otherParentInfoRequired) {
                if (!this.mothersWorksheetDto.otherEducationId) {
                    this.errors.push('Question 19: Father/Parent\'s Education is required.')
                }
                if (!this.mothersWorksheetDto.otherHispanicOriginId) {
                    this.errors.push('Question 20: Father/Parent\'s Hispanic Origin is required.')
                }
                if (!this.checkRaces(this.mothersWorksheetDto.otherRace)) {
                    this.errors.push('Question 21: At least one race must be selected for the father/parent.')
                }
                this.checkRaceText(this.mothersWorksheetDto.otherRace, '21')
            }
            if (!this.mothersWorksheetDto.heightFeet) {
                this.errors.push('Question 22: Mother\'s Height in feet is required.')
            }
            if (!this.mothersWorksheetDto.weight) {
                this.errors.push('Question 23: Mother\'s Pre-pregnancy Weight is required.')
            }
            if (!this.mothersWorksheetDto.wicYN) {
                this.errors.push('Question 24: Whether Mother Received WIC or not is required.')
            }
            if (!this.checkSmoking()) {
                this.errors.push('Question 25: Cigarette smoking before and during pregnancy is required. Please either select Never Smoked or enter in a number for either cigarettes or packs for each three month period.')
            }
            if (this.mothersWorksheetDto.prenatalCare == null) {
                this.errors.push('Question 26: Month Prenatal Care Began is required.')
            }
        },
        otherParentRule (v) {
            if (this.otherParentInfoRequired) {
                return !!v || 'Required'
            } else {
                return true
            }
        },
        otherParentSSNRule (v) {
            if (this.otherParentInfoRequired) {
                return (v && /^999999999|((?!(000|666|9))(\d{3}-?(?!(00))\d{2}-?(?!(0000))\d{4}))$/.test(v)) || 'Please input a valid SSN'
            } else {
                return true
            }
        }
    }
}
</script>
